import { CheckoutCube } from "@assets";
import Image from "next/image";

const AnimatedCube = () => {
  return (
    <div className="cube">
      <div className="cube__wrapper">
        <div className="cube__container">
          {["front", "back", "left", "right", "top", "bottom"].map(
            (side, i) => (
              <div key={i} className={`cube__face cube__face--${side}`}>
                <Image src={CheckoutCube} alt="" />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default AnimatedCube;
